/**
 * The permission codes billing screens check by name, with the values of the
 * shell's `Permissions` (lib/permissions.ts). Each one is the code the API
 * route enforces.
 */
export const BILLING_PERMISSION_CODES = {
  INVOICE_CREATE: 'invoices:create',
  INVOICE_READ: 'invoices:read',
  INVOICE_UPDATE: 'invoices:update',
  INVOICE_DELETE: 'invoices:delete',
  INVOICE_SIGN: 'invoices:sign',
  INVOICE_CREDIT_NOTE: 'invoices:credit-note',
  INVOICE_PAYMENT_CANCEL: 'invoices:payment-cancel',
  INVOICE_ORIGINAL_RELEASE: 'invoices:original-release',
  PISPI_REQUEST_PAYMENT: 'pispi:request-payment',
  MCF_DECLARER_PANNE: 'mcf:declarer-panne',
} as const;

/** The codes under the name billing screens read them by. */
export const Permissions = BILLING_PERMISSION_CODES;
